import React from 'react';
import { Password } from 'primereact/password';
import classes from './PasswordInput.module.css';

// Masked password field with a show/hide 'eye' toggle, built on PrimeReact's Password.
// - no strength meter popup (feedback={false})
// - stretches to the width of its container
// - autoComplete defaults to "new-password" so the browser doesn't autofill the user's saved
//   Portal login into device/CCTV credential fields. Pass autoComplete="current-password" for login forms.
// Accepts `className` for the field's existing input styling, plus any normal input props (placeholder, required, onChange, ...).
const PasswordInput = React.forwardRef(({ id, className, wrapperClassName, style, inputStyle, autoComplete = "new-password", ...props }, ref) => (
    <Password
        {...props}
        inputId={id}
        inputRef={ref}
        feedback={false}
        toggleMask
        autoComplete={autoComplete}
        className={`${classes.wrapper} ${wrapperClassName || ''}`}
        inputClassName={className}
        style={style}
        inputStyle={{ width: "100%", ...inputStyle }}
    />
));

export default PasswordInput;
